import { combineReducers } from "@reduxjs/toolkit"
import { loginReducer } from "./reducers/login"


export const rootReducer = combineReducers({
  login: loginReducer,
})